import React, {useState, useEffect} from 'react';
import { Link, useParams } from 'react-router-dom';
import { faCog, faTv } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from 'axios';
import { API_URL } from '../global/components/Constants';
import { card } from '../utils/stylesUtils'; 
import { sortById } from '../utils/globalUtils';
import {useDispatch, useSelector} from 'react-redux';
import { topicData, setTopic, setTopicComponents } from '../slices/topicSlice';
import { getTopicComponents } from '../utils/api-services/topic';
import EditTopicLink from './components/EditTopicLink';
import ComponentItem from './components/ComponentItem';
import TopicComponentList from './components/TopicComponentList';
import './components/topic-styles.css';

function EditTopic() {

    const [allComponents, setAllComponents] = useState([]);
    const [components, setComponents] = useState([]);
    const [showAll, setShowAll] = useState(false);
    const [showAllHover, setShowAllHover] = useState(false);
    const [componentLoading, setComponentLoading] = useState(false);
    const [topicLoading, setTopicLoading] = useState("init");
    const [width, setWidth] = useState(window.innerWidth);

    const tpicData = useSelector(topicData);
    const dispatch = useDispatch();
    const topic = tpicData.topic;
    const topicComponents = tpicData.topicComponents;

    const isMobile = width <= 768;
    const device = isMobile?'mobile':'desktop';
    const { code } = useParams();

    useEffect(()=>{
        loadTopic();
        loadComponents();
    }, []);

    function loadTopic(){
        setTopicLoading("running");
        axios({
            method: 'get',
            url: API_URL + `topic/topic_by_slug?slug=${code}`,
        }).then((respose)=>{
            const obj = respose.data;
            if(obj.Success){
                setTopicLoading("completed");
                dispatch(setTopic(obj.Data));
            }
        });
    }

    function loadComponents(){
        setComponentLoading(true);
        axios({
            method: 'get',
            url: API_URL + `topic/components`,
        }).then((respose)=>{
            const obj = respose.data;
            if(obj.Success){
                setComponentLoading(false);
                setAllComponents(obj.Data);
                const count = isMobile? 2: 8;
                setComponents(obj.Data.slice(0,count));
            }
        });
    }

    function handleShowAllHover(state){
        setShowAllHover(state);
    };

    function updateShowAll(){
        setShowAll(!showAll);
    }

    const styles = {
        page:{
            paddingTop: 40
        },
        topic:{
            container:{
            },  
            title: {
                marginBottom: 15,
                fontSize: 24
            },
        },
        topicItem:{
            marginBottom: 8
        },
        component:{
            title: {
                color: "#666",
                marginBottom: 2,
                fontSize: 16,
                fontWeight: 500
            },
            info: {
                color: "#666",
                fontSize: 13,
                fontWeight: 400
            },
            showAllBtn:{
                background: showAllHover?'#efefef':'#fff',
                margin: '10px 5px',
                padding:'3px 15px',
                border:'1px solid #0a66c2',
                borderRadius:30,
                alignItems: 'center',
                outline: 'none',
                boxShadow: 'none',
                transition: 'none',
            },
            showAllBtnTxt:{
                color: '#0a66c2',
                fontSize: 15,
                marginBottom: 0
            }
        }
    }

    return (
        <div style={styles.page}>
        <div className='container'>
        
            <div className='row'>
                <div className='col-md-3'></div>
                <div className='col-md-9'>

                    <div style={card.wrap}>
                        <div style={styles.topic.container}>
                            <h4 style={styles.topic.title}>{topic.Title}</h4>
                            <div style={styles.link}>
                                <EditTopicLink code = {topic.Slug} entry = "edit" />
                            </div>
                        </div>
                    </div>

                    <div style={card.wrap}>
                        <div style={card.head}>
                            <h4 style={styles.component.title}>Components</h4>
                            <div style={styles.component.info}>Select a component to add to topic</div>
                        </div>
                        <div style={card.bodyThinGrey}>
                            {showAll?
                                allComponents.map(itm=>(<ComponentItem topic={topic} obj={itm} containerId = {0} closeSelect = {null} />)):
                                components.map(itm=>(<ComponentItem topic={topic} obj={itm} containerId = {0} closeSelect = {null} />))
                            }
                            <Link onClick={()=>updateShowAll()} style={styles.component.showAllBtn} className='btn' onMouseEnter={()=>handleShowAllHover(true)} onMouseLeave={()=>handleShowAllHover(false)}>
                                <div style={styles.component.showAllBtnTxt}>{showAll?"Show less":"Show all"}</div>
                            </Link>
                        </div>
                    </div>

                    <div style={card.wrap}>
                        <TopicComponentList code={code} edit={true} />
                    </div>
                </div>
            </div>
        </div>
        </div>
    )

}

export default EditTopic;